import {Injectable} from '@angular/core';
import {
  DialogData,
  ProjektDaten
} from './components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {FilterSucheItem} from './filterSucheModel';
import * as moment from 'moment';
import {FilterItem} from '../projektverwaltung/filter.model';
import {NodeItem} from '../projektverwaltung/node.model';
import {Z} from "@angular/cdk/keycodes";
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';

type ZeitOutputResponse = CollectionApiResponse<DialogData>;
type ProjektOutputResponse = CollectionApiResponse<ProjektDaten>;
type FilterSeekDateResponse = CollectionApiResponse<FilterSucheItem>;
type Nodes = CollectionApiResponse<NodeItem>;

@Injectable({ providedIn: 'root'})

export class ZeitService {

  constructor(private http: HttpClient) { }

  /**
   * shows the time table
   *
   * @returns - An observable that emits the added parts of timetable
   */
  public getAll(): Observable<ZeitOutputResponse> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    const session = sessionStorage.getItem('session');
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getAll_select_zeit.php?userId=${userId}&${session}`) as Observable<ZeitOutputResponse>;
  }

  /**
   * Adds an parts of time to the backend
   *
   * @param zeitTeile - The parts of TB_Zeit to add to the table
   * @returns - An observable that emits the added parts of timetable
   *
   * Values of projectslevel hand over also in this add()
   */
  public add(): Observable<DialogData> {
    let userId;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
       userId = sessionStorage.getItem('zeitUserId');
    }
    else{
       userId = sessionStorage.getItem('userId');
    }
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/post_test_dummy.php?userId=${userId}&${sessionStorage.getItem('session')}`) as Observable<DialogData>;
  }

  /**
   * Edits an time entry
   *
   * @return An Observable that emits the edited address
   * @param Zeit = time       Time entry contents the edited Address
   */
  public edit(Zeit: DialogData): Observable<DialogData> {
    return this.http.put( window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/put_update_zeit.php?${sessionStorage.getItem('session')}`, Zeit) as Observable<DialogData>;
  }

  /**
   * Deletes an entry in the time table
   *
   * @return An Observable that emits the deleted Zeit
   * @param Zeit = time       Time entry contents the id of the time entry
   */
  public del(Zeit: DialogData): Observable<DialogData> {
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/delete_zeit.php?${sessionStorage.getItem('session')}`, Zeit) as Observable<DialogData>;
  }

  public getSaldo(userId: number): Observable<SaldoItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/auswertungen/getSaldo.php?${sessionStorage.getItem('session')}&userId=${userId}`) as Observable<
      SaldoItem
      >;
  }

  /* Alle Projekt Daten holen */
  public getAllProjects(): Observable<ProjektOutputResponse> {
    console.log('hier');
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getAllProjects_zeit.php?${sessionStorage.getItem('session')}`) as Observable<ProjektOutputResponse>;
  }

  /* Wert der level Box 0. Tauschen der id  */
  public box2(prj: ProjektDaten): Observable<ProjektOutputResponse> {
    const pID = prj.toString();
    const params = new HttpParams()
      .set('id', pID);
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/get_Part_Projects_zeit.php?${sessionStorage.getItem('session')}`,  { params }) as Observable<ProjektOutputResponse>;
  }

  /* Suchewerte */
  public seek(wert: DialogData): Observable<ZeitOutputResponse> {
    const schW = wert.toString();
    const params = new HttpParams()
      .set('suchWerte', schW);
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/get_seek_zeit.php?${sessionStorage.getItem('session')}`,  { params }) as Observable<ZeitOutputResponse>;
  }

  /*Filter Suche Datum nach Joel*/
  public getFilteredSeekDate(filterOption: string, item: FilterSucheItem): Observable<ZeitOutputResponse> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }

    const filter = filterOption;
    const filterItem = item;
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getFilteredSeekDate.php?userId=${userId}&filter=${filter}&${sessionStorage.getItem('session')}`, filterItem) as Observable<
      ZeitOutputResponse
      >;
  }

  /* Alle Projekt Daten holen */
  public getFerienReport(jahr: number, mitarbeiter: number[]): Observable<ProjektOutputResponse> {
    console.log('hier');
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/auswertungen/getFerienReport.php?${sessionStorage.getItem('session')}&jahr=${jahr}`, mitarbeiter) as Observable<ProjektOutputResponse>;
  }

  public getIstZeit(datum: string): Observable<number[]> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }

    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getIstZeit.php?${sessionStorage.getItem('session')}&datum=${datum}&userId=${userId}`) as Observable<number[]>;
  }

  public getSelectboxProjects(projektId: number): Observable<Nodes> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/get_Selectbox_Projects.php?${sessionStorage.getItem('session')}&id=${projektId}&userId=${userId}`) as Observable<
      Nodes
      >;
  }

  public setTimeToZero(zeit: DialogData): Observable<DialogData> {
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/setTimeToZero.php?${sessionStorage.getItem('session')}`, zeit) as Observable<DialogData>;
  }

  /* Alle Projekt Daten holen */
  public setAlleVerrechnet(zeit: DialogData): Observable<DialogData> {
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/setAlleVerrechnet.php?${sessionStorage.getItem('session')}`, zeit) as Observable<DialogData>;
  }

  public  checkIfUserisLoggedIn(): boolean{
    if ( isNaN( Number(sessionStorage.getItem('zeitUserId')))){
      return true;
    }
    return false;
}
}
